import { lazy } from 'react';
import { Routes } from './utils/renderRoutes';
import _ from 'lodash'
import { getDetailPath, getPath, MAKE_SERVICE, MAKE_SERVICE_MAP, SERVICE_LOG_DETAIL, SERVICE_LOG_DETAIL_MAP } from '@/views/SubscribeService/constants'
import { MENU, MENU_MAP } from '@/constants/menu'
import { upperCap } from '@/utils';

const subscribeServiceRoutes: Routes[] = [
    {
        title: MENU_MAP[MENU.SUBSCRIBE_SERVICE],
        path: `/${MENU.SUBSCRIBE_SERVICE}`,
        component: lazy(() => import('@/views/SubscribeService')),
        children: [
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.MANAGE],
                path: getPath(MAKE_SERVICE.MANAGE),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.MANAGE)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.REPLACE_MAKE],
                path: getPath(MAKE_SERVICE.REPLACE_MAKE),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.REPLACE_MAKE)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.SHOPING],
                path: getPath(MAKE_SERVICE.SHOPING),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.SHOPING)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.SA],
                path: getPath(MAKE_SERVICE.SA),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.SA)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.LOUNGE],
                path: getPath(MAKE_SERVICE.LOUNGE),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOUNGE)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.PARKING],
                path: getPath(MAKE_SERVICE.PARKING),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.PARKING)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.LOG],
                path: getPath(MAKE_SERVICE.LOG),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOG)}`)),
                children: [
                    {
                        title: SERVICE_LOG_DETAIL_MAP[SERVICE_LOG_DETAIL.LIST],
                        path: getDetailPath(SERVICE_LOG_DETAIL.LIST),
                        component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOG)}/${upperCap(SERVICE_LOG_DETAIL.LIST)}`)),
                    },
                    {
                        title: SERVICE_LOG_DETAIL_MAP[SERVICE_LOG_DETAIL.SHOPING],
                        path: `${getDetailPath(SERVICE_LOG_DETAIL.SHOPING)}/:id`,
                        component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOG)}/${upperCap(SERVICE_LOG_DETAIL.SHOPING)}`)),
                    },
                    {
                        title: SERVICE_LOG_DETAIL_MAP[SERVICE_LOG_DETAIL.PARKING],
                        path: `${getDetailPath(SERVICE_LOG_DETAIL.PARKING)}/:id`,
                        component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOG)}/${upperCap(SERVICE_LOG_DETAIL.PARKING)}`)),
                    },
                    {
                        title: SERVICE_LOG_DETAIL_MAP[SERVICE_LOG_DETAIL.SA],
                        path: `${getDetailPath(SERVICE_LOG_DETAIL.SA)}/:id`,
                        component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOG)}/${upperCap(SERVICE_LOG_DETAIL.SA)}`)),
                    },
                    {
                        title: SERVICE_LOG_DETAIL_MAP[SERVICE_LOG_DETAIL.LOUNGE],
                        path: `${getDetailPath(SERVICE_LOG_DETAIL.LOUNGE)}/:id`,
                        component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.LOG)}/${upperCap(SERVICE_LOG_DETAIL.LOUNGE)}`)),
                    },
                    {
                        redirect: true,
                        from: getPath(MAKE_SERVICE.LOG),
                        to: `${getPath(MAKE_SERVICE.LOG)}/list`,
                    },
                ]
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.MARGIN],
                path: getPath(MAKE_SERVICE.MARGIN),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.MARGIN)}`))
            },
            {
                title: MAKE_SERVICE_MAP[MAKE_SERVICE.MARGIN_QUERY],
                path: getPath(MAKE_SERVICE.MARGIN_QUERY),
                component: lazy(() => import(`@/views/SubscribeService/${upperCap(MAKE_SERVICE.MARGIN_QUERY)}`))
            },
            {
                redirect: true,
                from: `/${MENU.SUBSCRIBE_SERVICE}`,
                to: `/${MENU.SUBSCRIBE_SERVICE}/${MAKE_SERVICE.MANAGE}`,
            },
        ]
    },
];
export default subscribeServiceRoutes;